import { getVideoKind } from './VideoPlayer';

const byPosition = (a, b) => (a.position ?? Infinity) - (b.position ?? Infinity);

export const buildGalleryList = (images = [], coverImage) => {
    if (!images.length) return [];

    const imageItems = [];
    const videoItems = [];

    images.forEach((item) => {
        const kind = getVideoKind(item);
        if (kind === 'youtube' || kind === 'custom') {
            videoItems.push(item);
        } else {
            imageItems.push({ ...item, type: 'image' });
        }
    });

    imageItems.sort(byPosition);
    videoItems.sort(byPosition);

    const seen = new Set();
    const dedupedImages = imageItems.filter((img) => {
        if (seen.has(img.itemImageSrc)) return false;
        seen.add(img.itemImageSrc);
        return true;
    });

    let sortedImages = dedupedImages;
    if (coverImage) {
        const idx = dedupedImages.findIndex((img) => img.itemImageSrc === coverImage);
        if (idx === -1) {
            sortedImages = [
                { _id: 'cover', itemImageSrc: coverImage, type: 'image', alt: '', title: '' },
                ...dedupedImages,
            ];
        }
    }

    return [...sortedImages, ...videoItems];
};

export const addImageToTop = (images = [], newImageUrl) =>
    buildGalleryList(images, newImageUrl);
